import { Stack, SxProps } from '@mui/material';
import { FC } from 'react';

interface ICustomFieldSet {
  sx?: SxProps;
  children?: React.ReactNode;
}

export const CustomFieldset: FC<ICustomFieldSet> = (props) => {
  const style: SxProps = {
    display: 'inherit',
    flexDirection: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    gap: '20px',
    width: '100%',
    ...props.sx,
  };

  return (
    <Stack sx={{ ...style }} component='fieldset'>
      {props.children}
    </Stack>
  );
};
